import { getEnvVariableByKey } from '../../../utils/tenantUtils';

export const getLocalizationFlagOverrides = (): Record<string, string> => {
  try {
    return JSON.parse(
      getEnvVariableByKey('REACT_APP_LOCALIZATION_FLAG_OVERRIDES') ?? '{}'
    );
  } catch {
    return {};
  }
};

export const resolveFlagCode = (countryCode?: string) => {
  if (!countryCode) return undefined;

  const inputCountryCode = countryCode.toUpperCase().trim();
  const resolvedCountryCode =
    getLocalizationFlagOverrides()[inputCountryCode] ?? inputCountryCode;

  const flagCode = resolvedCountryCode.toLowerCase().trim();
  return flagCode === 'en' ? 'gb' : flagCode; // always map EN → GB
};
